import type { HilPresentationRequestEnvelope } from '@bizfirst/hil-types';
import { useHilStore } from '../store/hilStore';

export function useHilQueue(): {
  active: HilPresentationRequestEnvelope | null;
  pending: HilPresentationRequestEnvelope[];
  count: number;
} {
  const active = useHilStore((s) => s.active);
  const pending = useHilStore((s) => s.pending);
  return { active, pending, count: (active ? 1 : 0) + pending.length };
}
